import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@kinde-oss/kinde-auth-react/react-router";

import Login from "../account/login";
import CompleteProfile from "../account/completeProfile";
import Home from "../home";
import Layout from "../hoc/layout";
import Entries from "../entries";
import ErrorBoundary from "../errorBoundary";
import ErrorPage from "./errorPage";
import Players from "../players";
import Player from "../players/player";
import Profile from "../profile";
import AdminActions from "../admin";
import MyRecord from "../myrecord";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "my-record",
        element: (
          <ErrorBoundary>
            <ProtectedRoute>
              <MyRecord />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "pba-log",
        element: <Home />,
      },
      {
        path: "players",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <Players />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "players/:bsa_number",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <Player />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "entries",
        element: (
          <ErrorBoundary>
            <ProtectedRoute>
              <Entries />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "profile",
        element: (
          <ErrorBoundary>
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "admin",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <AdminActions />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: (
      <ErrorBoundary>
        <Login />
      </ErrorBoundary>
    ),
  },
  {
    path: "/complete-profile",
    element: (
      <ErrorBoundary>
        <ProtectedRoute>
          <CompleteProfile />
        </ProtectedRoute>
      </ErrorBoundary>
    ),
  },
]);
